import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { Config } from "../../Config";
import FaqImage from "../../assets/images/faq.png";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import FaqQuestions from "../../components/FaqQuestions/FaqQuestions";
import Preloader from "../../components/Preloader/Preloader";
import "./Faq.scss";
import "./Responsive.scss";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const Faq = (props) => {
  const [faq, setFaq] = useState([]);
  const [preloader, setPreloader] = useState(false);
  const user = useSelector((state) => state.user);
  const breadCrumbData = [
    { title: "خانه", link: "/" },
    { title: "سوالات متداول", link: "/faq" },
  ];

  useEffect(() => {
    Config.pageUp();
    getAllFaqs();
  }, []);

  const getAllFaqs = () => {
    setPreloader(true);
    axios
      .get(
        "/FAQ/GetAllCategoriesWithQuestions",
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setFaq(result.data);
        setPreloader(false);
      })
      .catch((error) => {
        setPreloader(false);
        // console.log(error);
      });
  };

  const openQuestion = (e) => {
    let questionItems = document.querySelectorAll(".questionItems");

    if (e.target.classList.contains("active")) {
      e.target.classList.remove("active");
      e.target.style.height = "50px";
    } else {
      for (let i = 0; i < questionItems.length; i++) {
        questionItems[i].classList.remove("active");
        questionItems[i].style.height = "50px";
      }
      e.target.classList.add("active");
      e.target.style.height = "max-content";
    }
  };
  return (
    <section className="faqWrapper mobile">
      <Helmet>
        {/* <title>ایران رگالو | سوالات متداول</title> */}
        <title>{Config.helmetTitle} | سوالات متداول</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      {/* {preloader && <Preloader active={preloader} />} */}
      <BreadCrumb breadCrumbData={breadCrumbData} />
      <div className="desktop">
        <div className="faqContents">
          <div className="faqHeader">
            <div className="rSide">
              <p className="title"> سوالات متدوال </p>
              <p className="description">
                در این بخش می توانید سوالات متداولی که توسط مشتریان و مخاطبان پرسیده می شود را مشاهده نمائید.مشاهده این
                پرسش و پاسخ ها موجب پاسخگویی به سوالات شما عزیزان خواهد شد.پیشنهاد می کنیم همه این سوال و جواب را مطالعه
                فرمائید.ممکن است سوالی در حال حاضر برای شما مهم نباشد اما در حین کار با نرم افزار نیاز به پاسخ آن داشته
                باشید.وجود بخش پرسش و پاسخ به این مفهوم نیست که سایر روش های پشتیبانی در دستور کار قرار نمی گیرد.
              </p>
            </div>
            <div className="lSide">
              <img src={FaqImage} alt="faq image" />
            </div>
          </div>
        </div>
      </div>
      {faq.length > 0 && <FaqQuestions sectionTitle="پرسش و پاسخ" questions={faq} openQuestion={openQuestion} />}
      {/* // <SkeletonTheme highlightColor={Config.skeletonHighlightColor}>
        //   <div className="faqQuestion">
        //     <div className="desktop">
        //       <div className="faqContents" style={{ marginTop: "30px" }}>
        //         <Skeleton */}
      {/* //           containerClassName="questionWrapper"
        //           style={{ minHeight: "50px" }}
        //           className="skeleton faqSkeleton"
        //           count={4}
        //         /> */}
      {/* //       </div> */}
      {/* //     </div> */}
      {/* //   </div> */}
      {/* // </SkeletonTheme> */}
      {/* // )} */}
    </section>
  );
};

export default React.memo(Faq);
